import { render, staticRenderFns } from "./DownloadableResourcesCTA.vue?vue&type=template&id=d0d75c0c"
import script from "./DownloadableResourcesCTA.vue?vue&type=script&lang=js"
export * from "./DownloadableResourcesCTA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports